import { OnboardingWord } from "@shared_types";

const ONBOARDING_WORDS_KEY = "onboardingWords";

function normalizeWords(words: OnboardingWord[]): OnboardingWord[] {
  const seen = new Set<string>();
  const result: OnboardingWord[] = [];
  for (const word of words) {
    const text = word.word.trim();
    const translation = word.translation.trim();
    if (!text || !translation) continue;
    const key = text.toLocaleLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    result.push({ word: text, translation });
  }
  return result;
}

export function saveStoredOnboardingWords(words: OnboardingWord[]): void {
  const normalized = normalizeWords(words);
  localStorage.setItem(ONBOARDING_WORDS_KEY, JSON.stringify(normalized));
}

export function getStoredOnboardingWords(): OnboardingWord[] {
  const raw = localStorage.getItem(ONBOARDING_WORDS_KEY);
  if (!raw) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return normalizeWords(
      parsed.map((item) => {
        const record =
          item && typeof item === "object"
            ? (item as Record<string, unknown>)
            : {};
        return {
          word: typeof record.word === "string" ? record.word : "",
          translation:
            typeof record.translation === "string" ? record.translation : "",
        };
      }),
    );
  } catch {
    return [];
  }
}

export function clearStoredOnboardingWords(): void {
  localStorage.removeItem(ONBOARDING_WORDS_KEY);
}
